import { useState } from "react";
import Seo from "@/components/base/Seo";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/base/BackToTop";
import Breadcrumb from "@/components/base/Breadcrumb";
import { faqItems } from "@/mocks/faq";

const faqLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqItems.map((item) => ({
    "@type": "Question",
    name: item.question,
    acceptedAnswer: { "@type": "Answer", text: item.answer },
  })),
};

const breadcrumbLd = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    { "@type": "ListItem", position: 1, name: "首页", item: "https://comworld1.github.io/" },
    { "@type": "ListItem", position: 2, name: "常见问题", item: "https://comworld1.github.io/faq" },
  ],
};

export default function Faq() {
  const [openId, setOpenId] = useState<string | null>(faqItems[0].id);

  return (
    <>
      <Seo
        title="洞洞杂货铺漫画常见问题 - 洞洞含义、阅读与世界观答疑"
        description="关于洞洞杂货铺漫画的常见问题解答：洞洞杂货铺漫画是什么？洞洞是什么意思？在哪里阅读？如何理解它的世界观？一篇为你答疑。"
        keywords="洞洞杂货铺漫画是什么,洞洞是什么意思,洞洞杂货铺常见问题,洞洞杂货铺世界观"
        canonicalPath="/faq"
        jsonLd={[faqLd, breadcrumbLd]}
      />
      <Navbar />
      <main>
        <div className="mx-auto w-full max-w-6xl px-4 pt-8 md:px-6">
          <Breadcrumb items={[{ label: "常见问题" }]} />
        </div>

        <div className="mx-auto w-full max-w-3xl px-4 py-8 md:px-6 md:py-10">
          <span className="inline-flex rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900 whitespace-nowrap">
            常见问题
          </span>
          <h1 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
            读者们最常问的事
          </h1>
          <p className="mt-4 text-sm leading-7 text-foreground-700 md:text-base">
            从洞洞杂货铺漫画是什么、洞洞含义到底是什么，
            到在哪里阅读、如何理解它的世界观——这些最常见的问题，我们在这里一次说清楚。
          </p>

          <div className="mt-8 space-y-3">
            {faqItems.map((item) => {
              const isOpen = openId === item.id;
              return (
                <div
                  key={item.id}
                  className="overflow-hidden rounded-2xl bg-background-100/70 ring-1 ring-background-200/70"
                >
                  <button
                    type="button"
                    onClick={() => setOpenId(isOpen ? null : item.id)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <h2 className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                      {item.question}
                    </h2>
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-50 text-foreground-700 transition-transform duration-300 ${
                        isOpen ? "rotate-180" : ""
                      }`}
                    >
                      <i className="ri-arrow-down-s-line"></i>
                    </span>
                  </button>
                  {isOpen && (
                    <p className="px-5 pb-5 text-sm leading-7 text-foreground-700">
                      {item.answer}
                    </p>
                  )}
                </div>
              );
            })}
          </div>

          <div className="mt-8 rounded-2xl bg-primary-100/60 p-5 text-center">
            <p className="text-sm text-primary-900">
              还有其他问题想了解？欢迎
              <a href="/contact" className="mx-1 font-medium underline underline-offset-4">
                联系我们
              </a>
              ，我们很乐意为你解答。
            </p>
          </div>
        </div>
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}